import "./Footer.css";
import { useLocalContext } from "../../context/LocalContext";
// 👇 adjust the path to wherever your services.js actually lives
import { services } from "../data/ServicesList.js";

const Footer = () => {
  const { webinfo = {} } = useLocalContext();
  const year = new Date().getFullYear();

  const brandName = webinfo.name || "Your Brand";

  const handleSubscribe = (e) => {
    e.preventDefault();
    const email = e.target.elements.email?.value;
    if (!email) return;
    window.location.href = `mailto:${
      webinfo.email || "hello@example.com"
    }?subject=Subscribe&body=Please subscribe ${email} to updates.`;
  };

  return (
    <footer className="ft2" aria-label={`${brandName} footer`}>
      <div className="ft2-shell">
        {/* TOP: main grid */}
        <div className="ft2-main">
          {/* Brand / narrative */}
          <section className="ft2-brand" aria-label="About">
            <a href="/" className="ft2-logo" aria-label={`${brandName} home`}>
              <span className="ft2-logo-mark" />
              <span className="ft2-logo-text">{brandName}</span>
            </a>

            <p className="ft2-tagline">
              A small, senior-led team that turns scattered websites, funnels and
              campaigns into one joined-up growth system your team can actually run.
            </p>

            {/* Micro stats */}
            <div className="ft2-stats">
              <div className="ft2-stat">
                <span className="k">30+ launches</span>
                <span className="d">sites, funnels & growth projects</span>
              </div>
              <div className="ft2-stat">
                <span className="k">10+ markets</span>
                <span className="d">served across time zones</span>
              </div>
              <div className="ft2-stat">
                <span className="k">90%+</span>
                <span className="d">repeat & retainer work</span>
              </div>
            </div>

            {/* Newsletter */}
            <form
              className="ft2-news"
              onSubmit={handleSubscribe}
              aria-label="Get occasional playbooks and templates"
            >
              <label htmlFor="ft-email" className="sr-only">
                Email address
              </label>
              <input
                id="ft-email"
                name="email"
                type="email"
                required
                placeholder="you@company.com"
                autoComplete="email"
              />
              <button type="submit" className="ft2-btn-primary">
                Send me field notes
              </button>
            </form>
            <p className="ft2-news-note">
              A few times a year, not weekly spam. Real examples, checklists and systems
              you can steal.
            </p>
          </section>

          {/* Navigation: Services (dynamic from services.js) */}
          <nav className="ft2-col" aria-labelledby="ft-work-head">
            <h4 id="ft-work-head">Services</h4>
            <ul>
              {Array.isArray(services) &&
                services.map((service) => (
                  <li key={service.id || service.slug || service.title}>
                    <a href={`/services/${service.slug}`}>
                      {service.title}
                    </a>
                  </li>
                ))}
            </ul>
          </nav>

          {/* Navigation: Company / resources */}
          <nav className="ft2-col" aria-labelledby="ft-company-head">
            <h4 id="ft-company-head">Company & resources</h4>
            <ul>
              <li>
                <a href="/about">About the studio</a>
              </li>
              <li>
                <a href="/process">How projects run</a>
              </li>
              <li>
                <a href="/our-strategies">Playbooks & strategy notes</a>
              </li>
              <li>
                <a href="/services">Pricing & engagement models</a>
              </li>
              <li>
                <a href="/contact">Book a chemistry call</a>
              </li>
            </ul>
          </nav>

          {/* Contact / social */}
          <section className="ft2-contact" aria-labelledby="ft-contact-head">
            <h4 id="ft-contact-head">Contact & practicals</h4>
            <address className="ft2-addr">
              <div>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${webinfo.email || "hello@example.com"}`}>
                  {webinfo.email || "hello@example.com"}
                </a>
              </div>
              <div>
                <strong>Phone:</strong>{" "}
                <a href={`tel:${webinfo.phonecall || ""}`}>
                  {webinfo.phone || "+91 80000 00000"}
                </a>
              </div>
              <div>
                <strong>Address:</strong>{" "}
                {webinfo.address || "Remote-first • Serving clients worldwide"}
              </div>
              <div className="ft2-hours">
                <strong>Hours:</strong>{" "}
                {webinfo.hours || "Mon–Sat · 10:00–19:00 IST"}
              </div>
            </address>

            <div className="ft2-social" aria-label="Social links">
              <a
                href={webinfo.linkedin || "#"}
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="currentColor"
                    d="M4.98 3.5A2.5 2.5 0 1 1 2.5 6a2.5 2.5 0 0 1 2.48-2.5zM3 8h4v13H3zM9 8h3.8v1.9h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.08V21H17v-5.6c0-1.33-.02-3.05-1.86-3.05-1.86 0-2.15 1.45-2.15 2.95V21H9z"
                  />
                </svg>
              </a>
              <a
                href={webinfo.twitter || "#"}
                target="_blank"
                rel="noreferrer"
                aria-label="Twitter / X"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="currentColor"
                    d="M18.244 2H21l-6.52 7.455L22 22h-6.24l-4.88-6.4L5.2 22H2l7.08-8.08L2 2h6.32l4.48 5.92L18.244 2Zm-1.1 18h1.8L7.02 4H5.18l11.964 16Z"
                  />
                </svg>
              </a>
              <a
                href={webinfo.instagram || "#"}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="currentColor"
                    d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7Zm5 3.5a5.5 5.5 0 1 1 0 11.001A5.5 5.5 0 0 1 12 7.5Zm0 2a3.5 3.5 0 1 0 0 7.001 3.5 3.5 0 0 0 0-7.001Zm5.75-2.25a1 1 0 1 1 0 2.001 1 1 0 0 1 0-2.001Z"
                  />
                </svg>
              </a>
            </div>

            <div className="ft2-badges">
              <span>Strategy-first builds</span>
              <span>Async & timezone-friendly</span>
              <span>NDA & white-label friendly</span>
            </div>
          </section>
        </div>

        {/* BOTTOM BAR */}
        <div className="ft2-bottom">
          <p>
            © {year} {brandName}. All rights reserved.
          </p>
          <nav className="ft2-legal" aria-label="Legal links">
            <a href="/terms-and-condition">Terms</a>
            <a href="/privacy-policy">Privacy</a>
            <a href="/disclaimer">Disclaimer</a>
          </nav>
        </div>

        {/* Thin disclaimer line */}
        <div
          className="ft2-disclaimer"
          role="note"
          aria-label="Site content disclaimer"
        >
          Nothing here is legal, financial, or guaranteed-results advice. We share
          patterns, not promises—let’s talk about what fits your context.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
